import { useEffect, useState } from 'react'

const QUERY = '(prefers-reduced-motion: reduce)'

export const useReducedMotion = (): boolean => {
    const [reduced, setReduced] = useState(false)

    useEffect(() => {
        const media = window.matchMedia(QUERY)
        const update = (): void => setReduced(media.matches)

        update()
        media.addEventListener('change', update)

        return () => media.removeEventListener('change', update)
    }, [])

    return reduced
}
